module.exports = __webpack_public_path__ + "img/lf1.bd63f358.png";